/**
 * BEPRO Shop - Inicijalizacija
 */
import Cart from './cart';
import AddToCart from './add-to-cart';
import initCheckout from './checkout';
import initAccount from './account';

export function initShop() {
	// Provjeri da li je shop aktivan
	if (!window.beproShop || !window.beproShop.enabled) return;

	Cart.init();
	AddToCart();

	// Inicijaliziraj checkout ako smo na checkout stranici
	if (document.querySelector('.js-checkout-form') || document.querySelector('.js-checkout-empty')) {
		initCheckout();
	}

	// Inicijaliziraj account ako smo na moj-racun stranici
	if (document.querySelector('.my-account')) {
		initAccount();
	}
}
